<iframe id="inlineFrameExample" title=" Frame shared" [src]="sanitizeSharedUrl" style="display : none;"></iframe>

<div [ngSwitch]="loaded" class="full-size">
  <div *ngSwitchCase="'NLOAD'">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div *ngSwitchCase="'LOAD'" class="full-size">
    <app-drag-ndrog-pool-array-container></app-drag-ndrog-pool-array-container>
  </div>
</div>

<alert></alert>